import * as React from 'react';
import { connect } from 'react-redux';
import Api from '../../services/Api';
import { ApiResponse } from 'apisauce';
import { SaveNewReport, GetDatasets } from './redux-objects/actions';
//import { powerbi } from 'powerbi';
import {
  service,
  factories,
  models,
  IEmbedConfiguration,
} from 'powerbi-client';
import { Button } from 'react-bootstrap';
import './PowerBiReport.css';
import * as urls from '../shared/urls';
import { UserInfo } from '../Login/common/defaults';
import { IPbiReport, IPbiDataset } from './business-objects/types';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';

export interface IPowerBiCreateReportProps {
  datasetId?: string; // not using this
  serviceURL: string;
  currentUser: UserInfo;
  SaveNewReport?: (url: string, report: IPbiReport) => Promise<void>;
  history: any;
}

const powerbi = new service.Service(
  factories.hpmFactory,
  factories.wpmpFactory,
  factories.routerFactory
);

class PowerBiCreateReport extends React.Component<IPowerBiCreateReportProps> {
  reportRef: React.Ref<HTMLDivElement>;
  reportContainer: HTMLElement;
  loading: JSX.Element;

  constructor(props: IPowerBiCreateReportProps) {
    super(props);
    this.state = { accessToken: '', embedUrl: '', error: [] };
    this.reportRef = React.createRef();

    this.handleSave = this.handleSave.bind(this);
    // Report container
    this.loading = (
      <div
        id={'reportContainer'} // + this.props.containerId}
        ref={this.reportRef}
        className='reportContainer'
      >
        Loading the report...
      </div>
    );
  }

  recentlySavedReportIds: string[] = [];

  componentDidMount() {
    if (this.reportRef !== null) {
      this.reportContainer = this.reportRef['current'];
    }
  }

  handleSave = (reportData: any) => {
    // to prevent powerbi from saving same report multiple times due to event handler being called multiple times
    if (this.recentlySavedReportIds.some(id => id === reportData.reportObjectId))
      return;
    this.recentlySavedReportIds.push(reportData.reportObjectId);

    // example data:
    // error: undefined
    // originalReportObjectId: "Invalid or no ReportId"
    // reportName: "qwer2"
    // reportObjectId: "b42b2c8f-7453-4641-ad3a-36b7e66e8af5"
    // saveAs: true
    const report: IPbiReport = {
      active: true,
      reportId: reportData.reportObjectId,
      name: reportData.reportName,
      reportTypeId: 1,
    };

    this.props
      .SaveNewReport(urls.POWERBI_SAVE_NEW_REPORT, report)
      .then((result: any) => {
        console.log('result', result);
        toast.success('Saved!');
        console.log('props', this.props);
        this.props.history.push('/PowerBiReports');
      });
  };

  doeEmbed = () => {
    if (this.reportRef !== null) {
      this.reportContainer = this.reportRef['current'];
    }

    const handleSave = (a: any) => this.handleSave(a);

    Api.get(`PBI/GetReportCreateToken?datasetId=${this.props.datasetId}`).then((result: ApiResponse<any>) => {
      //const embedData = $.parseJSON(result.data);
      const embedData = result.data;
      const embedCreateConfiguration = {
        type: 'report',
        tokenType: models.TokenType.Embed,
        accessToken: embedData.accessToken,
        embedUrl: embedData.embedUrl,
        datasetId: embedData.datasetId,
      };

      // Grab the reference to the div HTML element that will host the report
      const embedContainer = $('#reportContainer')[0];

      // Create report
      let report = powerbi.createReport(
        embedContainer,
        embedCreateConfiguration
      );

      // Report.off removes a given event handler if it exists.
      report.off('loaded');

      // Report.on will add an event handler which prints to Log window.
      report.on('loaded', function () {
      });

      // Report.off removes a given event handler if it exists.
      report.off('rendered');

      // Report.on will add an event handler which prints to Log window.
      report.on('rendered', function () {
      });

      report.off('error');
      report.on('error', function (event) {
        console.log(event.detail);
      });

      // report.off removes a given event handler if it exists.
      report.off('saved');
      report.on('saved', function (event: CustomEvent) {
        handleSave(event.detail);
      });
    });
  };
  // React function
  componentWillUnmount(): void {
    powerbi.reset(this.reportContainer);
  }
  public render() {
    this.doeEmbed();
    return this.loading;
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  SaveNewReport,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PowerBiCreateReport)
);
